import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
// Custom base query with error handling
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL, EndpointsSlug } from "./endpoints";

export const classicService = createApi({
  reducerPath: "classicService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["classic_level"],
  endpoints: (builder) => ({
    getAllClassicLevels: builder.query({
      query: ({ page, limit }) => ({
        url: EndpointsSlug.GET_CLASSIC_LEVELS,
        method: "GET",
        params: {
          page,
          limit,
        },
      }),
      providesTags: ["classic_level"],
    }),
    deleteClassicLevel: builder.mutation({
      query: (levelId) => ({
        url: `${EndpointsSlug.DELETE_CLASSIC_LEVEL}/${levelId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["classic_level"],
    }),
    // getClassicLevelBySlug: builder.query({
    //   query: () => ({
    //     url: EndpointsSlug.GET_CLASSIC_LEVEL_BY_SLUG,
    //     method: "GET",
    //   }),
    // }),

    createClassicLevel: builder.mutation({
      query: (payload) => ({
        url: EndpointsSlug.ADD_CLASSIC_LEVEL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["classic_level"],
    }),
  }),
});

export const {
  useGetAllClassicLevelsQuery,
  useDeleteClassicLevelMutation,
  useCreateClassicLevelMutation,
} = classicService;
export default classicService;
